import React from 'react';
import BaseComponent from './BaseComponent';
import Button from './Button';
import Style from './LectureIndicator.cssmodule.less';
import { HomeworkStatusTypes, LectureIndicatorStatus } from '../../Constants';

class LectureIndicator extends BaseComponent {
    constructor(props) {
        super(props);
        this.setTheme(props.theme);
    }

    setTheme(theme) {
        const themeStyle = this.getTheme(theme, 'LECTURE_INDICATOR');
        this.Style = themeStyle || Style;
    }

    createClassName(content) {
        const { homeworkStatus = HomeworkStatusTypes.NONE } = this.props;
        let status = content.status;

        if (
            homeworkStatus === HomeworkStatusTypes.DUE_LAPSE &&
            status !== LectureIndicatorStatus.SUBMITTED
        ) {
            status = LectureIndicatorStatus.RESOLVED;
        }

        return `${this.Style.indicator} ${status}`;
    }

    createIndicator() {
        const indicator = [];
        for (let i = 0; i < this.props.content.length; i++) {
            indicator.push(
                <Button
                    key={`indicatorButton${i}`}
                    className={this.createClassName(this.props.content[i])}
                    onClick={(e) => {
                        if ('onClick' in this.props) {
                            this.props.onClick(e, i);
                        }
                    }}
                >
                    <span>{`${i + 1}`}</span>
                </Button>
            );
        }

        return <div>{indicator}</div>;
    }

    createIndicatorName() {
        let className = `${this.props.className} `;
        return `${className}${this.Style.lectureIndicator}`;
    }

    render() {
        return (
            <div className={this.createIndicatorName()}>
                {this.createIndicator()}
            </div>
        );
    }
}

LectureIndicator.displayName = 'LectureIndicator';
LectureIndicator.propTypes = {};

export default LectureIndicator;



// WEBPACK FOOTER //
// ./components/CommonSet/LectureIndicator.js